import dynamic from 'next/dynamic'
import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'

const DMPrimaryButton = dynamic(
  () =>
    import('@decormatters/dm-theme').then(
      component => component.DMPrimaryButton
    ),
  { ssr: false }
)

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const NotFoundPage = () => {
  return (
    <Wrapper>
      <p>We can't find the page you're looking for 😞</p>
      <br />
      <div>
        <Link href="/">
          <DMPrimaryButton>Go to homepage</DMPrimaryButton>
        </Link>
      </div>
    </Wrapper>
  )
}

export default NotFoundPage
